import React, { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Burger, ExitBurger, Logo } from '../../ui/icons';
import { useDispatch, useSelector } from "react-redux";
import useWindowWidth from "../../ui/hooks/useWindowWidth";
import { getUser } from "../../store/authSlice";
import { useTranslation } from 'react-i18next';

const Layout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const slug = window.location.pathname;
    const { token } = useSelector(state => state.auth);
    const { token: registerToken } = useSelector(state => state.form);
    const [active, setActive] = useState(slug);
    const [menuOpen, setMenuOpen] = useState(false);
    const { t, i18n } = useTranslation();
    const links = [
        { name: t('nav.main'), url: '/' },
        { name: t('nav.aboutOAA'), url: '/aboutoaa' },
        { name: t('nav.theCourse'), url: '/aboutthecourse' },
        { name: t('nav.certification'), url: '/certification' },
        // { name: t('nav.tuitionWaiver'), url: '/oaacommunity', disabled: true },
    ];
    const width = useWindowWidth();
    const { user } = useSelector((store) => store.auth);

    const handleLogout = () => {
        navigate("/profile");
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    useEffect(() => {
        dispatch(getUser());
    }, []);

    const footerLinks = [
    ...links,
    { name: t('footer.terms'), url: '/terms' },
    { name: t('footer.privacy'), url: '/privacy_policy' },
    ];

    return (
        <>
            <header className="px-[20px] sm:px-[50px] py-[14px] sm:py-[17px] h-[74px]">
                <nav className="flex justify-between items-center relative bg-white">
                    <div className='flex items-center w-[100%] justify-between pe-3'>
                        <div className='flex items-center w-[100%]'>
                            <div className="w-[100px] sm:w-[100px] flex items-center">
                                <Link to='/'>
                                    <Logo />
                                </Link>
                            </div>
                            <ul
                                className={`fixed top-0 left-0 h-[100vh] lg:h-auto bg-[rgba(10,31,68,0.81)] z-50 p-6 shadow-lg
                                    transform transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"
                                } lg:translate-x-0 lg:relative lg:p-0 lg:shadow-none lg:flex lg:items-center lg:space-x-6 lg:bg-transparent`}
                            >
                                <button
                                    className="absolute top-4 right-6 text-white text-3xl lg:hidden"
                                    onClick={() => setMenuOpen(false)}
                                >
                                    <ExitBurger />
                                </button>
                                <div
                                    className="flex flex-col space-y-4 lg:flex-row lg:space-y-0 lg:space-x-6 pt-[70px] lg:pt-0 ml-[30px]">
                                    {/* {
                                        width <= 1024 && (<Link to={"/passingcourse/1"} className='text-center bg-[#FFE6E6] p-[10px_14px] rounded-xl font-semibold hover:bg-[#FFe1e2] whitespace-nowrap'>
                                            {t('nav.myCourse')}
                                        </Link>)
                                    } */}
                                    {links.map((link, idx) => (
                                        <li key={idx} className="lg:inline-block block py-2">
                                            {/* {links.length - 1 === idx ? (
                                                <span
                                                    className={`link__header font-bold text-white lg:text-gray-300 relative after:content-[''] after:absolute after:w-full after:h-[2px] after:bg-white md:after:gray after:left-0 after:bottom-[-2px] after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100 ${active === link.url ? "after:scale-x-100" : ""}`}
                                                    title={"Coming Soon"}
                                                >
                                                    {link.name}
                                                </span>
                                            ) : ( */}
                                                <Link
                                                    to={link.url}
                                                    className={`link__header font-bold text-white lg:text-black relative after:content-[''] after:absolute
                                                        after:w-full after:h-[2px] after:bg-white lg:after:bg-black after:left-0 after:bottom-[-2px]
                                                        after:scale-x-0 after:transition-transform after:duration-300
                                                        hover:after:scale-x-100 ${active === link.url ? "after:scale-x-100" : ""}`}
                                                    onClick={() => {
                                                        setActive(link.url);
                                                        setMenuOpen(false);
                                                    }}
                                                >
                                                    {link.name}
                                                </Link>
                                            {/* )} */}
                                        </li>
                                    ))}
                                </div>
                            </ul>
                        </div>
                        {/* <div className="flex items-center gap-[10px] ml-4">
                            <button
                                onClick={() => changeLanguage('en')}
                                className={`text-black text-sm ${i18n.language === 'en' ? 'font-bold' : 'hover:underline'}`}
                            >
                                EN
                            </button>
                            <span className="text-black">/</span>
                            <button
                                onClick={() => changeLanguage('ru')}
                                className={`text-black text-sm ${i18n.language === 'ru' ? 'font-bold' : 'hover:underline'}`}
                            >
                                RU
                            </button>
                        </div> */}
                    </div>
                    <div className="flex items-center gap-[10px]">
                        {token || registerToken ? (
                            <div>
                                {width <= 1024 ? (
                                    <div className='flex items-center gap-[18px]'>
                                        <button onClick={handleLogout} className="text-black hover:underline">
                                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="1" width="39" height="39" rx="19.5" fill="#F8F8F8" />
                                                <rect x="0.5" y="1" width="39" height="39" rx="19.5" stroke="#D7D7D7" />
                                                <path
                                                    d="M20 10.1C21.3261 10.1 22.5979 10.6268 23.5355 11.5645C24.4732 12.5021 25 13.7739 25 15.1C25 16.4261 24.4732 17.6979 23.5355 18.6355C22.5979 19.5732 21.3261 20.1 20 20.1C18.6739 20.1 17.4021 19.5732 16.4645 18.6355C15.5268 17.6979 15 16.4261 15 15.1C15 13.7739 15.5268 12.5021 16.4645 11.5645C17.4021 10.6268 18.6739 10.1 20 10.1ZM20 22.6C25.525 22.6 30 24.8375 30 27.6V30.1H10V27.6C10 24.8375 14.475 22.6 20 22.6Z"
                                                    fill="#D7D7D7"
                                                />
                                            </svg>
                                        </button>
                                        <button className="ml-4 text-black text-xl lg:hidden" onClick={() => setMenuOpen(!menuOpen)}>
                                            <Burger />
                                        </button>
                                    </div>
                                ) : (
                                    <div className='flex items-center gap-[30px]'>
                                        <Link to={"/passingcourse/1"} className='bg-[#FFE6E6] p-[10px_14px] rounded-xl font-semibold hover:bg-[#FFe1e2] whitespace-nowrap'>
                                            {t('nav.myCourse')}
                                        </Link>
                                        <button onClick={handleLogout} className="text-black hover:underline flex items-center gap-[14px]">
                                            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="1" width="39" height="39" rx="19.5" fill="#F8F8F8" />
                                                <rect x="0.5" y="1" width="39" height="39" rx="19.5" stroke="#D7D7D7" />
                                                <path
                                                    d="M20 10.1C21.3261 10.1 22.5979 10.6268 23.5355 11.5645C24.4732 12.5021 25 13.7739 25 15.1C25 16.4261 24.4732 17.6979 23.5355 18.6355C22.5979 19.5732 21.3261 20.1 20 20.1C18.6739 20.1 17.4021 19.5732 16.4645 18.6355C15.5268 17.6979 15 16.4261 15 15.1C15 13.7739 15.5268 12.5021 16.4645 11.5645C17.4021 10.6268 18.6739 10.1 20 10.1ZM20 22.6C25.525 22.6 30 24.8375 30 27.6V30.1H10V27.6C10 24.8375 14.475 22.6 20 22.6Z"
                                                    fill="#D7D7D7"
                                                />
                                            </svg>
                                            <p className='text-[16px] font-semibold'>
                                                {user?.first_name} {user?.last_name}
                                            </p>
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="flex items-center">
                                <Link to="/signin" className="text-black text-lg hover:underline">{t('nav.login')}</Link>
                                <span className="mx-3">|</span>
                                <Link to="/signup" className="text-black text-lg hover:underline whitespace-nowrap">{t('nav.signin')}</Link>
                                <button className="ml-4 text-black text-xl lg:hidden" onClick={() => setMenuOpen(!menuOpen)}>
                                    <Burger />
                                </button>
                            </div>
                        )}
                    </div>
                </nav>
            </header>
            <Outlet />
            <footer className="bg-[#8C1C1C] text-white py-8 md:py-12 px-4 sm:px-6 md:px-[50px]">
                <div className="max-w-[1024px] m-auto">
                    <div>
                        <ul className="flex items-center justify-between">
                            {footerLinks.map((page, index) => (
                                <li key={index} className={`hover:text-[#c6a982] transition ${page.disabled ? 'opacity-50 cursor-pointer' : ''}`}>
                                {page.disabled ? <span>{page.name}</span> : <Link to={page.url}>{page.name}</Link>}
                                </li>
                            ))}
                        </ul>
                        <ul className="flex items-center justify-center mt-4">
                            <li className={`hover:text-[#c6a982] transition`}>
                            © All rights reserved
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Layout;